import {MoveDrawer} from '../../../mode/MoveDrawer';
import {Point} from '@app/modules/svg/model/Point';
import {MoveDrawable} from '../../../type/MoveDrawable';
import {NumberLineView2} from '@app/modules/svg/element/complex/cartesian2/NumberLineView2';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {Axis} from '@app/modules/svg/element/complex/cartesian2/CoordinatePlaneView2';

export class DrawNumberLine2 extends MoveDrawer {
  public xAxis: Axis = undefined;
  protected createDrawableElement(position: Point): MoveDrawable {
    return new NumberLineView2(
      this.drawTool.container,
      {overEvent: true, globalStyle: true},
      {x: position.x, y: position.y, width: 1, height: 1},
      this.xAxis
    );
  }

  protected override onIsNotComplete(call: boolean): void {
    if (!this._drawableElement) {
      return;
    }
    (this._drawableElement as unknown as MoveDrawable).__drawSize__({
      x: this.startPosition.x - 200,
      y: this.startPosition.y - 50,
      width: 400,
      height: 100
    });
    this._drawableElement.refPoint = this._drawableElement.center;
  }
  protected override onEnd(call: boolean): void {
  }

  public override start(call: boolean): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.NUMBER_LINE_TOOL2_ON);
    }
  }
  public override stop(call: boolean): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.NUMBER_LINE_TOOL2_OFF);
    }
  }

  public _new(): DrawNumberLine2 {
    return new DrawNumberLine2(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.NUMBER_LINE2;
  }
}
